import {
    CHALLENGES_REQUESTED,
    CHALLENGES_SUCCEEDED,
    CHALLENGES_FAILED,
    CHALLENGE_UPDATE_REQUESTED,
    CHALLENGE_UPDATE_SUCCEEDED,
    CHALLENGE_UPDATE_FAILED,
    PARTICIPATED_CHALLENGES_REQUESTED,
    PARTICIPATED_CHALLENGES_SUCCEEDED,
    PARTICIPATED_CHALLENGES_FAILED,
} from './constants';

const initialState = {
    // initial state of challenges
    challenges: [],
    participated: [],
    // initial state of challenges loading state
    challengesLoading: false,
    // initial state of updated Challenge
    updatedChallenge: null,
    // index of challenge in array which is to be updated on Active Toggle
    challengeToUpdateIndex: null,
    // initial state of error
    error: '',
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PARTICIPATED_CHALLENGES_REQUESTED:
        case CHALLENGES_REQUESTED: {
            const { challengesLoading } = action;
            return {
                ...state,
                challengesLoading,
            };
        }
        case CHALLENGES_SUCCEEDED: {
            const { challenges } = action;
            const { challengesLoading } = action;
            return {
                ...state,
                challenges,
                challengesLoading,
            };
        }
        case PARTICIPATED_CHALLENGES_SUCCEEDED: {
            const { challenges } = action;
            const { challengesLoading } = action;
            return {
                ...state,
                participated: challenges,
                challengesLoading,
            };
        }
        case PARTICIPATED_CHALLENGES_FAILED:
        case CHALLENGES_FAILED:
        case CHALLENGE_UPDATE_FAILED: {
            const { error } = action;
            const { challengesLoading } = action;
            return {
                ...state,
                error,
                challengesLoading,
            };
        }
        case CHALLENGE_UPDATE_REQUESTED: {
            const { challengeToUpdateIndex } = action;
            return {
                ...state,
                challengeToUpdateIndex,
            };
        }
        case CHALLENGE_UPDATE_SUCCEEDED: {
            const { updatedChallenge } = action;
            const { challengeToUpdateIndex } = action;
            let challenges = [...state.challenges];
            challenges[challengeToUpdateIndex].isPublished =
                updatedChallenge.isPublished;
            return { ...state, challenges };
        }
        default:
            return state;
    }
}
